import styled from '@emotion/styled'
export const Banner = styled.div `
        background: url(${props=>props.bannerurl})no-repeat;
        background-size:cover;
        background-position:center;
        `;